export default __webpack_public_path__ + "static/media/srinagar1.f226b7ec.jpg";